<script setup lang="ts">
import { provide } from "vue"
import { EventVaultIdKey } from "@/providers/keys"

const props = defineProps({
  eventVaultId: {
    type: Number,
    default: undefined,
  },
})

provide(EventVaultIdKey, props.eventVaultId)
</script>

<template>
  <slot />
</template>
